import React from "react";
import { connect } from "react-redux";
import LimitLine from "../../GameHeader/Stats/LimitLine";
import { formatNumberForceSigned } from "../../../lib/commonFunctions";

const StoneBalance = ({ stoneBalance }) => (
  <React.Fragment>
    <h3 className="title">Stone balance</h3>
    Stone-miners: <span
    className={stoneBalance.production.miners > 0 ? "positive" : ""}>{formatNumberForceSigned(stoneBalance.production.miners)}</span><br/>
    {!!stoneBalance.production.guilds && <>
      Guild: <span className={"positive"}>{formatNumberForceSigned(stoneBalance.production.guilds)}</span><br />
    </>}
    Bricks production: <span
    className={stoneBalance.consumption > 0 ? "negative" : ""}>{formatNumberForceSigned(-stoneBalance.consumption)}</span>
    <br />
    <LimitLine
      amount={stoneBalance.limit.amount}
      limit={stoneBalance.limit.limit}
      market={stoneBalance.limit.market}
    />
  </React.Fragment>
);

const mapStateToProps = state => ({
  stoneBalance: state.governorate.resourceBalances.stone,
});

export default connect(mapStateToProps)(StoneBalance);
